import React from 'react';
import './classes/CourseandConferenceBlock.css';
import './classes/ConferencesBlock.css';
import { configData } from "../config";

// The "DEGREES" tile on the "jobs in sports" pages. On the Drupal site this is a
// hand-written block (block 65), so the text and start date are fixed here too. Its markup is the
// conference view's (view-conferences), so it takes the placed conferences' tile styles
// (conferences-block--placed, ConferencesBlock.css).
const DegreesBlock = () => {
    const link = '/content/sports-leadership-degrees';
    const title = 'Earn a Sports Leadership Degree Online';
    const description = 'With an online degree from Concordia University of Chicago (CUC), you can earn your master’s or doctorate from an accredited and respected university.';
    const image = configData.DRUPAL_LIVE_DOMAIN_URL + '/sites/default/files/Degree%20block%20image.jpg';

    return (
        <div className="conference-section conferences-block conferences-block--placed degrees-block">
            <h2>DEGREES</h2>

            <ul className="conference-list">
                <li className="conference-list__item">

                    {/* ---------------- Desktop Tile ---------------- */}
                    <div className="conference-tile--desktop">
                        <div className="conference-list__item-image-wrapper">
                            <a href={link}>
                                <img src={image} alt={title} loading="lazy" />
                            </a>
                        </div>

                        <div className="conference-list__item-details">
                            <div className="conference-list__item-title title">
                                <a href={link}>{title}</a>
                            </div>

                            <div className="conference-list__item-intro">
                                {description}
                            </div>
                        </div>

                        <div className="conference-list__item-deadline">
                            <div className="conference-list__item-deadline-badge">
                                <span className="badge__header">June</span>
                                <span className="badge__day">
                                    29
                                    {/* Block 65 ends the year with a no-break space, which sets it 2px left */}
                                    <span className="badge__year">2026&nbsp;</span>
                                </span>
                                <span className="badge__month">Degree</span>
                                <span className="badge__label">Start Date</span>
                            </div>

                            <div className="conference-list__item-badge-accent">
                                <a href={link}>
                                    <span className="badge__learn-more">LEARN MORE</span>
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* ---------------- Mobile Tile ---------------- */}
                    <div className="conference-tile--mobile">
                        <div className="views-field-wrap">
                            <div className="conference-list__item-mobile-header">
                                <div className="conference-list__item-avatar">
                                    <i>
                                        <img src={image} alt="" loading="lazy" />
                                    </i>
                                </div>

                                <div className="conference-list__item-title title">
                                    <a href={link}>{title}</a>
                                </div>
                            </div>

                            <div className="conference-list__item-deadline-badge">
                                <div className="badge__date">June 29, 2026</div>
                                <div className="badge__description">{description}</div>

                                <div className="badge__action-container">
                                    <span className="badge__action-btn">
                                        <a href={link}>LEARN MORE</a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    );
};

export default DegreesBlock;
